import Card from 'components/card';
import { useEffect, useState } from 'react';
import { getFile, uploadCompanyLogo } from 'interfaces/user';

const IMAGE_OPTIONS: { value: 'logo' | 'photo'; label: string; fileName: string }[] = [
    { value: 'logo', label: 'Logo de mon entreprise', fileName: 'company-logo.jpg' },
    { value: 'photo', label: 'Photo de ma boutique', fileName: 'shop-photo.jpg' },
];

const CommandPageShareImage = (props: { user: any; handleChange: any }) => {
    const { user, handleChange } = props;
    const [previews, setPreviews] = useState<{ [fileName: string]: string }>({});
    const [uploading, setUploading] = useState<string | null>(null);

    const selected = user?.shareEmailImageType || 'logo';

    const loadPreview = async (fileName: string) => {
        const res = await getFile(fileName);
        if (res?.data?.url) {
            setPreviews((prev) => ({ ...prev, [fileName]: res.data.url }));
        }
    };

    useEffect(() => {
        IMAGE_OPTIONS.forEach((opt) => loadPreview(opt.fileName));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelect = (value: 'logo' | 'photo') => {
        handleChange({ target: { id: 'shareEmailImageType', value } });
    };

    const handleFileChange = async (fileName: string, file: File) => {
        setPreviews((prev) => ({ ...prev, [fileName]: URL.createObjectURL(file) }));
        setUploading(fileName);
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileName', fileName);
        await uploadCompanyLogo(formData);
        setUploading(null);
        loadPreview(fileName);
    };

    return (
        <Card extra={'w-full mt-3 px-6 py-6 border'}>
            <div className="w-full px-1">
                <h4 className="text-xl font-medium">Image de l'email de partage</h4>
                <p className="mt-1 text-xs">
                    Choisissez l'image affichée dans l'email envoyé à vos clients
                    lorsque vous partagez votre boutique B2B.
                </p>
            </div>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {IMAGE_OPTIONS.map((opt) => (
                    <div
                        key={opt.value}
                        className={`flex flex-col gap-2 rounded-lg border p-3 ${
                            selected === opt.value
                                ? 'border-toola-500 bg-toola-500/10'
                                : 'border-gray-200'
                        }`}
                    >
                        <label
                            htmlFor={`share-image-${opt.value}`}
                            className="flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="radio"
                                id={`share-image-${opt.value}`}
                                name="shareEmailImageType"
                                checked={selected === opt.value}
                                onChange={() => handleSelect(opt.value)}
                            />
                            <span className="text-sm font-medium">{opt.label}</span>
                        </label>
                        {previews[opt.fileName] ? (
                            <img
                                src={previews[opt.fileName]}
                                alt={opt.label}
                                className="h-20 w-auto object-contain"
                            />
                        ) : (
                            <p className="text-xs text-gray-400">Aucune image</p>
                        )}
                        <input
                            type="file"
                            accept="image/*"
                            className="text-xs items-center justify-center rounded-xl border bg-white/0 px-2.5 py-2 outline-none"
                            disabled={uploading === opt.fileName}
                            onChange={(e) => {
                                if (e.target.files?.[0])
                                    handleFileChange(opt.fileName, e.target.files[0]);
                            }}
                        />
                    </div>
                ))}
            </div>
        </Card>
    );
};

export default CommandPageShareImage;
